export const tema = {
  cores: {
    primaria: {
      padrao: '#004F9F',
      variantes: {
        100: '#E6EDF5',
        200: '#CCDCEC',
        300: '#99B9D9',
        400: '#6695C5',
        500: '#3372B2',
        600: '#004F9F',
        700: '#003F7F',
        800: '#002F5F',
        900: '#002040',
        1000: '#001020',
      },
    },
    texto: '#0A0909',
    neutro: {
      0: '#FFFFFF',
      100: '#EAEBEC',
      200: '#D4D7D8',
      300: '#A9AEB1',
      400: '#6E757A',
      500: '#545D64',
      600: '#29353D',
      700: '#212A31',
      800: '#192025',
      900: '#101518',
      1000: '#080B0C',
      1100: '#0A0909',
    },
    media: '#6E757A',
    alerta: {
      padrao: '#FDDC69',
      contraste: '#7d5e00',
      variantes: {
        100: '#FFF7DC',
        200: '#FEEAA6',
        300: '#FDDC69',
        400: '#FBD120',
        500: '#FAC500',
        600: '#F9BB00',
        700: '#FBAC00',
        800: '#FD9800',
        900: '#FF8600',
        1000: ' #FF6200',
      },
    },
    erro: {
      padrao: '#DA1E28',
      variantes: {
        100: '#FBE9EA',
        200: '#F6D3D5',
        300: '#EDA8AB',
        400: '#BD5458',
        500: '#C83D42',
        600: '#DA1E28',
        700: '#A91E23',
        800: '#7F161A',
        900: '#540F12',
        1000: '#2A0709',
      },
    },
    info: {
      padrao: '#0D99F7',
      variantes: {
        100: '#E6F5FF',
        200: '#CDEBFF',
        300: '#9CD7FF',
        400: '#6AC2FF',
        500: '#39AEFF',
        600: '#0D99F7',
        700: '#067BCC',
        800: '#045C99',
        900: '#033E66',
        1000: '#011F33',
      },
    },
    sucesso: {
      padrao: '#28A44C',
      variantes: {
        100: '#EAF6ED',
        200: '#D4EDDB',
        300: '#A9DBB7',
        400: '#7EC894',
        500: '#53B670',
        600: '#28A44C',
        700: '#20833D',
        800: '#18622E',
        900: '#10421E',
        1000: '#08210F',
      },
    },
    suporte: {
      padrao: '#FF832B',
      variantes: {
        100: '#FFF3EA',
        200: '#FFE6D5',
        300: '#FFCDAA',
        400: '#FFB580',
        500: '#FF9C55',
        600: '#FF832B',
        700: '#CC6922',
        800: '#994F1A',
        900: '#663411',
        1000: '#331A09',
      },
    },
    processo: {
      padrao: '#8C63DA',
      variantes: {
        100: '#E8E0F8',
        200: '#DDD0F4',
        300: '#D1C1F0',
        400: '#BAA1E9',
        500: '#A382E1',
        600: '#8C63DA',
        700: '#704FAE',
        800: '#46326D',
        900: '#2A1E41',
        1000: '#1C142C',
      },
    },
  },
};
